//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DetailAdmSpisovyPlan.ts						</Name>
//    <Description> Dialog detailu sslsspl - Spisov� pl�n										</Description>
//    <Author>      FFIALA													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-03-10                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.15.2
//AdtGeneratorConfig:[ T:(sslsspl) GID:(Web.Det.Ts) V1:(spis_pl,aktivita,poznamka,dat_od,dat_do,dat_zmena,zmenu_prov,nazev,popis,priz_vycet,oddelovace,prirustek,spis_pl_ext) V2:() K1:() K2:() ]

namespace Gordic.Adm.WebControls {

	const { gcontent } = Decorators;

    /** inteface - Response slu�eb pro Detail */
    export interface IDetailAdmSpisovyPlanResponse {
        /** data v�stupu */
        data: Gordic.AdmIsl.Interface.GAdmSpisovyPlanReadDto,

        result: {
            /** data v�stupu */
            data: Gordic.AdmIsl.Interface.GAdmSpisovyPlanReadDto,
            /** chyby */
            errors: {
                /** zpr�va chyby */
                message: string
            }[],
            /** typ v�stupu operace */
            kind: Adm.Utils.GOperationResultKind
        }
    }

	//#endregion

	/** Dialog detailu  */
	@gcontent
    export class DetailAdmSpisovyPlan extends GContentBase<DetailBase> {

		//#region attributes

        private gridRemoteControl: Gordic.Components.GridRC<any>;
        private gridCssClass: string;

            /** PK - spis_pl */
            private spis_pl: string | null;
        
        /** data detailu */
        private data: Gordic.AdmIsl.Interface.GAdmSpisovyPlanReadDto;
		/** p��znak p��m�ho p��stupu na detail */
		private detailCommand: boolean
		/** Tab pro xxxx */
		//private strediskaTab: GStrediskaTab;

		//#endregion

		//#endregion


        /** onContentReady */
        public onContentReady() {
            this.init();
        }
		//#region ready & init

        public closing() {
            return DetailBase.CloseAction(this);
        }

        /** refreshDetail content */
        private refreshDetail(): void {

            this.HideAllFlash(); 
			this.load();
		}

        /** Na�ten� dat ze serveru na n�sledn� nastaven� na detail okn� */
        private loadData() {

            this.HideAllFlash(); 

            var fragments: string[] = [Utils.GAdmIslConst.detail];

            if (this.newRecord) {
                fragments.push(Utils.GAdmIslConst.defaultValuesForNewRecord);
            }

            var readResult: any = this.isl.AdmSpisovyPlan.read({
                data: { spis_pl: this.spis_pl },
                fragments: fragments
            } ).get();

            // SUCCESS
            readResult.done((output: IDetailAdmSpisovyPlanResponse) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.data = output.data;

                    this.sxsDetail = this.data.spis_pl;

                    this.MetaData = this.data.MetaData || null;
                    this.Permissions = this.data.Permissions || null;
                    this.createForm();

                    this.element.findFields().gfield("model", "apply", this.data);
                    // this.strediskaTab.getTab().appendTo(this.element);
                    // this.strediskaTab.setDataTogrid(this.data.Strediska);
                    if (this.newRecord) {
                        this.SetEditMode(true);       // p�i NEW je okno ihned p�epnuto do edit re�imu - mus� b�t p�ed setMenuButtons()
                        //this.strediskaTab.updateStrediskaAction(true);
                    }

                    this.SetMenuButtons(this.editMode);
                    this.actions.actOpenSeznamAdmSpisovyZnak?.enabled(!this.newRecord && !this.editMode);
                    this.actions.actExportSpisPlan?.enabled(!this.newRecord && !this.editMode);
                    this.actions.actOpenSeznamAdmSpisovyPlanStrediskoSpisovychUzlu?.enabled(!this.newRecord && !this.editMode && (this.data.priz_vycet || 0) == 1); 
                    this.createSidebar();
                    //this.createGTab();
                } else {
                    var errors = output.result.errors;
                    for (var index = 0; index < errors.length; index++) {
                        var error = errors[index];
                        this.ShowLoadError(error.message, index);
                    }
                }
            });
            // ERROR
            readResult.fail((err) => {
                console.error("Chyba na�ten�! " + err );
                this.ShowLoadError("jres:32131045!");
            });   
        } // loadData

        private updateGrid( dto: Gordic.AdmIsl.Interface.GAdmSpisovyPlanReadDto ): any {
            return this.isl.AdmSpisovyPlan.list({
              filters: { spis_pl: dto.spis_pl },
            }).getView()
        }

		//#endregion

        /** Ulo�en� dat formul��e do datab�ze */
        private saveData(nova_data: Gordic.AdmIsl.Interface.GAdmSpisovyPlanSaveDto): void {

            this.HideAllFlash(); 

            var upsertResult: any = this.isl.AdmSpisovyPlan.upsert({ data: nova_data }).get();

            upsertResult.done((output: IDetailAdmSpisovyPlanResponse) => {

                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderSslsspl");
                    this.refreshGrid(output.data, this.newRecord);
                    this.newRecord = false;
                    this.data = output.data; // prevezmu nova data vznikla ulozenim
                    this.sxsDetail = this.data.spis_pl;
                    this.MetaData = this.data.MetaData || null;
                    this.Permissions = this.data.Permissions || null;
                    this.createForm();                // znovu vytvo��m� cel� form 
                    this.element.findFields().gfield("model", "apply", this.data);  // nasetov�n�� nov�ch dat do detailu
                    //this.strediskaTab.getTab().appendTo(this.element);
                    //this.strediskaTab.setDataTogrid(this.data.Strediska);

                    this.SetEditMode(false);
                    this.SetMenuButtons(false);
                    //this.strediskaTab.updateStrediskaAction(false);
                    this.actions.actOpenSeznamAdmSpisovyZnak?.enabled(!this.newRecord && !this.editMode);
                    this.actions.actExportSpisPlan?.enabled(!this.newRecord && !this.editMode); 
                    this.actions.actOpenSeznamAdmSpisovyPlanStrediskoSpisovychUzlu?.enabled(!this.newRecord && !this.editMode && (this.data.priz_vycet || 0) == 1  ); 
                    this.ShowSaveSuccess();
                    this.createSidebar();
                }
                else {
                    var errors = output.result.errors;
                    for (var index = 0; index < errors.length; index++) {
                        var error = errors[index];
                        this.ShowSaveError(error.message, index);           // flash ne�sp�n�ho ulo�en�
                    }
                }

            });

            upsertResult.fail((err) => {
                console.error("Chyba ulo�en�! ");    
                this.ShowSaveError("jres:32000125!");   //RC 32000125 : Chyba ulo�en�
            });            
        }

        private refreshGrid(output: Gordic.AdmIsl.Interface.GAdmSpisovyPlanReadDto, newRecord: boolean) {
            var gridElement = this.gridRemoteControl as any;
            var grid = gridElement.gridInstance.element;
            if (grid.length != 0) {
                this.updateGrid(output).done((d: Gordic.Data.View) => {
                   var data = d.getDataRows(true, "data")[0];
                   var view: Gordic.Data.View = grid.ggrid("getView");
                   if (this.newRecord == true)
                      view.updateData(data, "add");
                   else
                      view.updateData(data, "update");
                   grid.ggrid("setData", view);
               });
            }
        }

		/** init content */
		private init() {

			DetailBase.DetailBaseInit(this);
			//this.strediskaTab = new GStrediskaTab();

			this.formElement = null;

			// lezu na detail ze seznamu a ne pomoc� linku
			if (this.detailCommand === false) {
				var GinListControlsObject = (Gin.DetailBuilderComponents as any).GinListControls.create(this);
				this.actions.addRange(GinListControlsObject.actions);
				this.createStatusBar(GinListControlsObject.statusBar);
				$.extend(this, GinListControlsObject.contentExtensions);
			}

			this.setTitle();
			this.createMenuBar();
			//this.createForm();
			this.loadData();            // to soucasne vytvori form podle nactenych dat; 
			this.createCommandBar();

            // lezu na detail ze seznamu a ne pomoc� linku
			if (this.detailCommand === false) {
				// vytvo�it �ipky na proch�zen� detailu
                (this as any).listControls_setup({
                    //gridRemoteControl: this.gridRemoteControl,
					//funkce, kter� ��dek z gridu p�etransformuje v dto pro zavol�n� this.load(dto); M��e vracet promise.
					rowToDto: function (gridState) {
						return {
                            spis_pl: gridState.currentRow.data.spis_pl,
						};
					},
					//template pro tooltip na �ipce n�sleduj�c�
                    nextItemTemplate: "jres:33000155",
					//template pro tooltip na �ipce p�edchoz�
                    prevItemTemplate: "jres:33000156"
				});
				(this as any).listControls_updateCaptions();
            }
		}

		/** vytvo�it statusbar */
		private createStatusBar(GinListControlsObject?: any) {
			const bar: MenuParams[] = [];
			if (GinListControlsObject !== undefined) {
				bar.push.apply(bar, GinListControlsObject);
			}
			this.statusBar(bar);
		}

		//#endregion

		//#region data

        /** Skryt� v�ech flash */
        private HideAllFlash() {
            // skryji p��padn� Flash panely - mus�m za��t s �ist�m �t�tem
            this.hideFlash("idSaveSuccess");    
            this.hideFlash("idSaveError");  
            this.hideFlash("idLoadError");
            for (var index = 0; index < 10; index++) {
                this.hideFlash("idSaveError" + index);
                this.hideFlash("idLoadError" + index);
            }
        }
        /** Zobraz� p��znaku �sp�n�ho ulo�en� */
        private ShowSaveSuccess() {
            this.showFlash("jres:32000123", "g-state-success", 2000, "idSaveSuccess"); //RC 32000123 : Detail byl �sp�n� ulo�en
        }
        /** Zobraz� p��znaku chyby p�i ulo�en� dat */
        private ShowSaveError(text: string, index?: number) {
            if (index === undefined)
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idSaveError" ); //RC 32000124 : Chyba
            else
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idSaveError" + index); //RC 32000124 : Chyba
        }
        /** Zobraz� p��znaku chyby p�i na�ten� dat */
        private ShowLoadError(text: string, index?: number) {
            if (index === undefined)
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idLoadError"); //RC 32000124 : Chyba
            else
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idLoadError" + index); //RC 32000124 : Chyba
        }

        

		//#region title

		/** nastavit titulek dialogu */
		private setTitle() {

            var title = "";

            if (this.newRecord === false) {
                title = "jres:32131033"  	//RC 32131033 : Detail
            }
            else {
                title = "jres:32000121" //RC 32000121 : Nov� z�znam
            }

            this.title = title;

		}


		//#endregion

		//#region form

		/** vytvo�it formul�� a na�ten� dat ze serveru */
        private createForm() {
            var nemenne = "jres:32131150"; //RC 32131150 : Nem�nn�
            this.MakeForm("FormAdmSpisovyPlanService");
            this.MakeSection("jres:29808065"); //RC 29808065 :  Spisov� pl�n
            this.MakeField("spis_pl");
            this.MakeField("nazev");
            this.MakeField("popis");
            this.MakeField("poznamka");

            this.MakeField("oddelovace");
            this.MakeField("prirustek");
            this.MakeField("spis_pl_ext");
            this.MakeSelectField("priz_vycet", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_vycet=value.priz_an" });

            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_od");
            this.MakeField("dat_do");
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });

            var form = this.FinishMakeForm();

        }

		//#endregion

		//#region menubar

		private nextAndPreviousAction(next: boolean) {
		    var obj: any;
		    if (next == true)
		        obj = this.gridRemoteControl.current().nextRow.data;
		    else
		        obj = this.gridRemoteControl.current().prevRow.data;
		    this.gridRemoteControl.move(next);
		    var gridElement = this.gridRemoteControl as any;
		    Dialogs.DetailAdmSpisovyPlanDlg($.content(gridElement.gridInstance.element), { spis_pl: obj.spis_pl, grid:gridElement.gridInstance.element, newRecord: false })
		this.close();
		}

		/** vytvo�it menubar */
		private createMenuBar() {

			const menuBar: MenuParams[] = [];

			this.actions.addRange({ 
			actNext: {
			        name: "actNext",
			        caption: "jres:33000001",  //RC 33000001 : Dal���
			        captionVisible: "never",
			        icon: "gi-arrow-down",
			        run: (ev, ctx) => {
			            this.nextAndPreviousAction(true);
			        }
			    },
			    actPrevious: {
			        name: "actPrevious",
			        caption: "jres:33000002", //RC 33000002 : P�edchoz�
			        captionVisible: "never",
			        icon: "gi-arrow-down gi-rot180",
			        run: (ev, ctx) => {
			            this.nextAndPreviousAction(false);
			        }
			    },
              actSaveRecord: {
                    visible: this.newRecord,
                    name: "actSaveRecord",
                    icon: "gi-save",
                    caption: "jres:32131041",			//RC 32131041 : Ulo�it
                    run: () => {
                        // kolekce dat
                        var nova_data: Gordic.AdmIsl.Interface.GAdmSpisovyPlanSaveDto = {};       // vytvo��m pr�zdn� objekt spr�vn�ho typu
                        this.findFields().gfield("model", "collect", nova_data);    // na�tu do n�j data z formul��e
                        //nova_data.Strediska = this.strediskaTab.getDataFromGrid();
                        this.saveData(nova_data);                                   // pokus�m se ulo�it data do DB
                    }
                },
                actEditRecord: {
                        visible: true,
                        name: "actEditRecord",
                        icon: "gi-pencil",
                        caption: "jres:32000120",			//RC 32000120 : Editace
                        run: () => {
                            this.SetEditMode(true);
                            this.SetMenuButtons(true);
			                this.actions.actOpenSeznamAdmSpisovyZnak?.enabled(!this.newRecord && !this.editMode); 
                            this.actions.actExportSpisPlan?.enabled(!this.newRecord && !this.editMode); 
                            this.actions.actOpenSeznamAdmSpisovyPlanStrediskoSpisovychUzlu?.enabled(!this.newRecord && !this.editMode); 
                            //this.strediskaTab.updateStrediskaAction(true);
                        }
                },
                actCancelSaveRecord: {
                        visible: false,
                        name: "actCancelSaveRecord",
                        icon: "gi-window-close",
                        caption: "jres:32000122",			//RC 32000122 : Ukon�it editaci
                        run: () => {
                            this.refreshDetail();           // ob�erstv�m p�vodn� data z datab�ze
                            this.HideAllFlash();
                            this.SetEditMode(false);
                            this.SetMenuButtons(false);
                            //this.strediskaTab.updateStrediskaAction(false);
                        }
                },
                actRefresh: {
                        icon: "gi-refresh",
                        name: "actRefresh",
                        caption: "jres:32131040",			//RC 32131040 : Ob�erstven�
                        run: () => {
                        this.refreshDetail();
                        }
                },
                actOpenSeznamAdmSpisovyZnak: {
                   icon: "fa-link",
                   caption: "jres:29808067", //RC 29808067 : Spisov� znaky
                   run: () => {
                      this.openSeznamAdmSpisovyZnak();
                   }
                },
                actOpenSeznamAdmSpisovyPlanStrediskoSpisovychUzlu: {
                   icon: "fa-link",
                   caption: "jres:32131164", //RC 32131164 : Spisov� pl�ny pro st�ediska
                   run: () => {
                      this.openSeznamAdmSpisovyPlanStrediskoSpisovychUzlu();
                   }
                },
                actExportSpisPlan: {
                    icon: "fa-download",
                    caption: "jres:33000032",
                    run: (ev, ctx) => {
                         this.dialogs.showModalWindow("Gordic.Adm.WebControls.SpisovyPlanExport", { spis_pl: this.data.spis_pl, spis_pl_nazev: this.data.nazev }, { height: 300, width: 500 });
                    }
                }
			});

			this.menuBar([
			    { action: this.actions.actSaveRecord, favorite: true },
			    { action: this.actions.actEditRecord, favorite: true },
			    { action: this.actions.actCancelSaveRecord, favorite: true, visible: !this.newRecord },
			    { action: this.actions.actRefresh, favorite: true, visible: !this.editMode },
			    { action: this.actions.actPrevious, favorite: true, align: "opposite", visible: !this.newRecord },
			    { action: this.actions.actNext, favorite: true, align: "opposite", visible: !this.newRecord },
                { action: this.actions.actOpenSeznamAdmSpisovyZnak, favorite: true, visible: !this.newRecord && !this.editMode },
                { action: this.actions.actOpenSeznamAdmSpisovyPlanStrediskoSpisovychUzlu, favorite: true, visible: !this.newRecord && !this.editMode }, 
                { action: this.actions.actExportSpisPlan, favorite: true, visible: !this.newRecord && !this.editMode }, 
			])
            if (this.gridRemoteControl.current()) {
                this.actions.actPrevious?.enabled(this.gridRemoteControl.current().prevRow != null);
                this.actions.actNext?.enabled(this.gridRemoteControl.current().nextRow != null);
            } else {
                this.actions.actPrevious?.enabled(false);
                this.actions.actNext?.enabled(false);
            }

			//this.menuBar(menuBar);

        }


		/** vytvo�it commandbar */
		private createCommandBar() {

			const commandBar: MenuParams[] = [];

            // CLOSE
			commandBar.push({								
				favorite: true,
				action: this.actions.add(new GAction({
					name: "actZavrit",
					icon: "gi-window-close",
					caption: "jres:32131042",				//RC 32131042 : Zav��t
					run: () => {
						this.close();
					}
				}))
			});

			this.commandBar(commandBar);
		}

		//#endregion

		//#region statusbar

		/** odstranit v�echny vlastn� t��dy ze statusbaru */
		private removeAllCustomClassOnStatusBar() {
			var myclass = $(".statusbar-aktivita-class").find(".g-static__text");
			myclass.removeClass("statusbar-aktivita-class-green");
			myclass.removeClass("statusbar-aktivita-class-blue");
			myclass.removeClass("statusbar-aktivita-class-red");
		}

		//#endregion

		//#region sidebar

		/** vytvo�it panel */
		private createPanel(): GSideBarPanelOptions {

			this.panelId = "panelNahled";

			let panel = {
				minWidth: 300,
				id: this.panelId,
				caption: "jres:32131038",							//RC 32131038 : N�hled
                leaf: "jres:32131038",								//RC 32131038 : N�hled
                icon: "gi-nahled",
				open: (ev, obj) => {
					this.refreshPanel(ITypePanel.Neurceno, $(ev.target))
				},
			} as GSideBarPanelOptions;

			return panel;
		}

		/** odstranit sidebar */
		private removeSidebar() {
			if (this.sidebar !== undefined) {
				this.sidebar.gsidebar("removeAll");
			}
		}

		/** vytvo�it sidebar */
		private createSidebar() {

			this.removeSidebar();
			var myPanels: GSideBarBarOptions[] = [];

			var auditPristupu = new Gordic.Adm.WebControls.AdmAuditPristupu();
			var panelAudit = auditPristupu.create( this.sxsDetail || "", this.MetaData?.typ_obj || 0);
			myPanels.push(panelAudit);

			//var extIdentifikace = new Gordic.Adm.WebControls.AdmExtIdentifikace();
			//var panelExtIdentifikace = extIdentifikace.create( this.sxsDetail || "", this.MetaData?.typ_obj || 0);
			//myPanels.push(panelExtIdentifikace);

			//var poznamky = new Gordic.Adm.WebControls.AdmPoznamky();
			//var panelPoznamky = poznamky.create(this,  this.sxsDetail || "", this.MetaData?.typ_obj || 0);
			//myPanels.push(panelPoznamky);

			this.sidebar = $(this.element).gsidebar({
				userSettings: this.userSettings,
				right: {
					pinned: true,
					panels: myPanels
				}
			});
		}

		/** ob�erstven� panelu v sidebaru */
		private refreshPanel(type: ITypePanel, elementPanel?: JQuery<HTMLElement>): void {

			var panel: JQuery<HTMLElement> | undefined;

			if (this.sidebar !== undefined) {
				panel = this.sidebar.gsidebar("getPanel", this.panelId);
			}
			else {
				panel = elementPanel;
			}

			if (panel !== undefined) {

				if (this.panelElement !== undefined) {
					this.panelElement.remove();
				}

				this.panelElement = $("<div>").appendTo(panel);

				//if (type === ITypePanel.HistorieSpusteni) {
				//	GridUtils.setPanelGrid("jres:32000055", this.row_historie_spusteni, this.gridFormatHistorieSpusteni, this.panelElement);
				//}
				//else {
					this.setPreviewEmpty();
				//}

			}

		}
        /** vytov�en� pr�zdn�ho sidebar panelu s n�hledek */
		private setPreviewEmpty(): void {
			var p7s_element = $("<div'>").addClass("Adm-p7s-class");
			p7s_element.appendTo(this.panelElement);
			p7s_element.text("jres:32131043"); //RC 32131043 : N�hled nen� k dispozici.
		}

		//#endregion

        private openSeznamAdmSpisovyZnak() {
            this.navigate("Gordic.Adm.WebControls.SeznamAdmSpisovyZnak", { spis_pl: this.data.spis_pl })
        }

        private openSeznamAdmSpisovyPlanStrediskoSpisovychUzlu() {
            this.navigate("Gordic.Adm.WebControls.SeznamAdmSpisovyPlanStrediskoSpisovychUzlu", { spis_pl: this.data.spis_pl })
        }
	}
}
